// this is an autogenerated file from App/Account/EmbeddableCoreMessageListener/PaymentsCreateInvoice/Treatment/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_EmbeddableCoreMessageListener_PaymentsCreateInvoice_Treatment($patient_id: numeric!) {
  vaxiom_txs(
    where: {
      tx_card: { patient_id: { _eq: $patient_id }, deleted: { _eq: false } }
    }
    order_by: {
      tx_card: { latest_appointment_booking_start_time: desc_nulls_last }
    }
  ) {
    id
    _id
    text: name
  }
}

`